'use client';

import type { ReactNode } from 'react';
import { toast as sonnerToast } from 'sonner';

type ToastVariant = 'default' | 'destructive' | 'success';

export interface ToastOptions {
  title?: ReactNode;
  description?: ReactNode;
  variant?: ToastVariant;
  duration?: number;
}

export type ToasterToast = ToastOptions;

const variantToast: Record<ToastVariant, typeof sonnerToast.success> = {
  default: sonnerToast,
  destructive: sonnerToast.error,
  success: sonnerToast.success,
};

const formatDescription = (description?: ReactNode): ReactNode =>
  typeof description === 'string' ? description.replaceAll(';', '\n') : description;

export function toast({ title, description, variant = 'default', duration }: ToastOptions) {
  return variantToast[variant](title, {
    description: formatDescription(description),
    duration,
  });
}

export function useToast() {
  return {
    toast,
    dismiss: (id?: string | number) => sonnerToast.dismiss(id),
  };
}
